import { resetUser } from "utils/analytics";
import getCSRFToken from "helpers/getCSRFToken";

export default function logout(newLocation?: string) {
  fetch("/auth/logout", {
    method: "DELETE",
    headers: {
      "X-CSRF-Token": getCSRFToken(),
    },
  }).then(() => {
    resetUser();
    window.location.href = newLocation || "/";
  });
}
